import {APP_INITIALIZER, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {firstValueFrom} from 'rxjs';
import {BaseConfigService} from './base-config.service';
import {ConfigService} from './config.service';
import {ContextConfigService} from './context-config.service';
import {PortalConfigService} from './portal-config.service';
import {FaviconService} from './favicon.service';


@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    BaseConfigService,
    ConfigService,
    ContextConfigService,
    PortalConfigService,
    FaviconService,
    {
      // INFO: Lädt die lokale config.json
      provide: APP_INITIALIZER,
      useFactory: (baseConfigService: BaseConfigService) => () => firstValueFrom(baseConfigService.loadConfig()),
      deps: [BaseConfigService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ConfigService) => () => firstValueFrom(configService.loadConfig()),
      deps: [ConfigService],
      multi: true,
    },
  ],
})
export class ServiceModule {
}
